export const qrIconStyle = {
  width: 44,
  height: 44,
  borderRadius: '50%',
  bgcolor: '#F0ECF8',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const dialogTitleStyle = {
  textAlign: 'right',
  pb: 0,
};

export const closeIconStyle = {
  cursor: 'pointer',
  color: '#B7B6BE',
  fontSize: 22,
};

export const dialogContentStyle = {
  pt: 1,
  pb: 4,
  px: { xs: 2.5, sm: 4 },
};

export const qrHeaderWrapperStyle = {
  display: 'flex',
  justifyContent: 'center',
  mb: 1.5,
};

export const qrHeaderIconStyle = {
  color: '#7F56D9',
  fontSize: 24,
};

export const popupTitleStyle = {
  textAlign: 'center',
  fontWeight: 700,
  color: '#2F2D3A',
  mb: 3.5,
  fontSize: { xs: '0.4rem', sm: '1.4rem' },
};

export const contentGridStyle = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
  gap: { xs: 3, sm: 12 },
  alignItems: 'start',
};

export const sectionTitleStyle = {
  textAlign: 'center',
  fontWeight: 700,
  color: '#2F2D3A',
  mb: 1.25,
  fontSize: '1.4rem',
};

export const highlightedWordStyle = {
  color: '#7F56D9',
};

export const sectionDescriptionStyle = {
  textAlign: 'center',
  color: '#4A4954',
  fontSize: '1.10rem',
  lineHeight: 1.35,
  minHeight: 58,
};

export const qrCardStyle = {
  mt: 2,
  p: 2.5,
  borderRadius: '14px',
  bgcolor: '#F5F4F8',
  display: 'flex',
  justifyContent: 'center',
};

export const qrImageStyle = {
  width: 160,
  height: 160,
  objectFit: 'contain',
};

export const actionButtonStyle = {
  mt: 1.5,
  fontSize: { xs: '0.8rem', sm: '0.8rem', md: '1rem' },
  textTransform: 'none',
  fontWeight: 700,
  py: 1.3,
  borderRadius: '10px',
  bgcolor: '#EEEAF8',
  color: '#7F56D9',
  boxShadow: 'none',
  '&:hover': { bgcolor: '#E3DCF4', boxShadow: 'none' },
};

export const rightColumnStyle = {
  position: 'relative',
};

export const monitorCardStyle = {
  mt: 2,
  p: 2.5,
  borderRadius: '14px',
  bgcolor: '#F5F4F8',
  height: 200,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const monitorCircleStyle = {
  width: 90,
  height: 90,
  borderRadius: '50%',
  bgcolor: '#ECEBF1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const monitorIconStyle = {
  color: '#7F56D9',
  fontSize: 34,
};
